const renderSortBy = (renderOptions, isFirstRender) => {
  const { options, currentRefinement, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const list = document.createElement("ul");
    list.className = "list-facet__list list-unstyled";

    options.forEach((option) => {
      const item = document.createElement("li");

      item.dataset.aisSortValue = option.value;

      item.innerHTML = `
        <label class="list-facet__item">
          ${option.label}
        </label>
      `;

      item.addEventListener("click", () => {
        refine(option.value);
      });

      list.appendChild(item);
    });

    widgetParams.container.appendChild(list);
  }

  const sortItems = widgetParams.container.querySelectorAll("li");
  const itemActiveClass = "list-facet__item--selected";

  sortItems.forEach((item) => {
    if (item.dataset.aisSortValue === currentRefinement) {
      item.querySelector("label").classList.add(itemActiveClass);
    } else {
      item.querySelector("label").classList.remove(itemActiveClass);
    }
  });
};

export const sortBy =
  window.instantsearch.connectors.connectSortBy(renderSortBy);
